var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"publication-band",style:(("background-color: " + _vm.color + "; color: " + _vm.textColor + "; " + (_vm.left ? 'left: 0' : 'right: 0') + "; " + (_vm.second ? 'top: 23px !important' : '') + "; " + (_vm.bottom ? 'bottom: 10px !important' : 'top: 0')))},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67e34a4c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/PublicationBand.vue
// module id = null
// module chunks = 